import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { TestItemsListFilterSchema } from './-zod-schema';

// テストセット詳細 > テスト項目タブ。
// 注: テストケース(明細 = TestCaseDetail)をこのタブに台帳一覧表示する。
// テストケース(ヘッダー = TestCaseHeader)情報は「テスト条件」(conditions)タブ
// 側に表示する棲み分け(ヘッダー表示は別途実装)。
// 評価結果タブ / 検索 / ページング状態は当面 client-side 処理し URL search に保持する。
// コンポーネントは index.lazy.tsx 側で遅延ロードして bundle 分割する。
export const Route = createFileRoute('/_stacktrace/test-sets/$id/_layout/test-items/')({
  validateSearch: zodValidator(TestItemsListFilterSchema)
});